import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { paths } from '../navigation/paths';
import { RequireAdmin, RequirePlayer } from './guards';
import { LandingPage } from '../pages/LandingPage';
import { AdminLoginPage } from '../pages/AdminLoginPage';
import { AdminPanelPage } from '../pages/AdminPanelPage';
import { PlayerViewPage } from '../pages/PlayerViewPage';
import { GameOverviewPage } from '../pages/GameOverviewPage';
import { CharacterSelectionPage } from '../pages/CharacterSelectionPage';
import { CharacterSheetPage } from '../pages/CharacterSheetPage';
import { CombatPage } from '../pages/CombatPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path={paths.landing} element={<LandingPage />} />
      <Route path={paths.login} element={<AdminLoginPage />} />
      <Route path={paths.play} element={<PlayerViewPage />} />
      <Route path="/play/join/:gameId" element={<PlayerViewPage />} />
      <Route
        path="/play/select/:gameId"
        element={(
          <RequirePlayer>
            <CharacterSelectionPage />
          </RequirePlayer>
        )}
      />
      <Route
        path={paths.hero}
        element={(
          <RequirePlayer>
            <CharacterSheetPage />
          </RequirePlayer>
        )}
      />
      <Route path="/master" element={<Navigate to={paths.masterGames} replace />} />
      <Route
        path="/master/games/new"
        element={(
          <RequireAdmin>
            <AdminPanelPage />
          </RequireAdmin>
        )}
      />
      <Route
        path="/master/games/:gameId/combat"
        element={(
          <RequireAdmin>
            <CombatPage />
          </RequireAdmin>
        )}
      />
      <Route
        path="/master/games/:gameId"
        element={(
          <RequireAdmin>
            <GameOverviewPage />
          </RequireAdmin>
        )}
      />
      <Route
        path="/master/:tab"
        element={(
          <RequireAdmin>
            <AdminPanelPage />
          </RequireAdmin>
        )}
      />
      <Route path="*" element={<Navigate to={paths.landing} replace />} />
    </Routes>
  );
}
